import apiUrl from "../../../../../utils/settings";
export const paginateDPUrl = () => {
  return apiUrl + '/user-orders/paginated';
};
export const orderDetailsUrl = () => {
  return apiUrl + `/user-orders/order-details`;
}
export const createDispatchPlanOrderUrl = () => {
  return apiUrl + '/user-orders/create-order';
};
